<div class="container mt-4 mb-4">
  <!-- LOADING SPINNER -->
  <div class="text-center" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Fetching your Aadhaar details...</p>
  </div>

  <div *ngIf="!isLoading && userData?.isAadhaarVerified">
    
    <!-- Profile Image -->
    <div class="row mb-4">
      <div class="col-md-12 text-center">
        <img [src]="profileImageUrl" alt="Profile Image" class="img-fluid rounded" style="width: 150px; height: 150px; object-fit: cover; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
      </div>
    </div>

    <!-- Personal Details Card -->
    <div class="card mb-4">
      <h5 class="card-header" [ngStyle]="getFirstStyles()">Candidate Details</h5>
      <div class="card-body">
        <div class="row p-2 text-justify">
          <div class="col-md-4">
            <label>First Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.firstName">
          </div>
          <div class="col-md-4">
            <label>Middle Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.middleName || ''">
          </div>
          <div class="col-md-4">
            <label>Last Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.lastName">
          </div>
        </div>

        <div class="row p-2 text-justify">
          <div class="col-md-4">
            <label>Date Of Birth (yyyy-mm-dd)</label>
            <input type="text" class="form-control" readonly [value]="userData?.dob">
          </div>
          <div class="col-md-4">
            <label>Gender</label>
            <input type="text" class="form-control" readonly [value]="userData?.gender?.name">
          </div>
          <div class="col-md-4">
            <label>Nationality</label>
            <input type="text" class="form-control" readonly [value]="userData?.nationality?.name">
          </div>
        </div>

        <div class="row p-2 text-justify">
          <div class="col-md-4">
            <label>Mobile Number</label>
            <input type="text" class="form-control" readonly [value]="userData?.phone">
          </div>
        </div>
      </div>
    </div>

    <!-- Father's Name Card -->
    <div class="card mb-4">
      <h5 class="card-header" [ngStyle]="getFirstStyles()">Father's Name</h5>
      <div class="card-body">
        <div class="row p-2 text-justify">
          <div class="col-md-4">
            <label>First Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.fatherFirstName">
          </div>
          <div class="col-md-4">
            <label>Middle Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.fatherMiddleName || ''">
          </div>
          <div class="col-md-4">
            <label>Last Name</label>
            <input type="text" class="form-control" readonly [value]="userData?.fatherLastName">
          </div>
        </div>
      </div>
    </div>

    <!-- Address Details Card -->
    <div class="card mb-4">
      <h5 class="card-header" [ngStyle]="getFirstStyles()">Permanent Address</h5>
      <div class="card-body">
        <div class="row p-2 text-justify">
          <div class="col-md-4">
            <label>Address Line 1</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.addr1">
          </div>
          <div class="col-md-4">
            <label>Address Line 2</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.addr2 || ''">
          </div>
          <div class="col-md-4">
            <label>Address Line 3</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.addr3 || ''">
          </div>
        </div>

        <div class="row p-2 text-justify">
          <div class="col-md-3">
            <label>District</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.district?.name">
          </div>
          <div class="col-md-3">
            <label>State</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.state">
          </div>
          <div class="col-md-3">
            <label>Country</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.country?.name">
          </div>
          <div class="col-md-3">
            <label>Pincode</label>
            <input type="text" class="form-control" readonly [value]="userData?.address?.pincode">
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="row p-2 mt-2">
      <div class="col-md-12 text-center">
        <button class="btn" [ngStyle]="getFirstStyles()" (click)="continueToDashboard()">
           Continue to Dashboard <i class="fas fa-arrow-circle-right"></i>
        </button>
      </div>
    </div>

  </div>
</div>
